import { Col, Flex } from 'antd';
import { ScheduledTaskDef } from '../../apis/mgmt/api';
import { ClickableProps, DataViewProps } from '../common/DataView';


export const ScheduledTaskDefCard = function (props:
    DataViewProps<ScheduledTaskDef> & ClickableProps<ScheduledTaskDef>
) {

    const data = props.data;

    const onClick = () => { data && props.onClick && props.onClick(data); }
    
    const sidePanelVisible = false; // props.sidePanelVisible || false; // TODO Get from context
    const sizes = sidePanelVisible? { xxl: 8, xl: 12, lg: 24 } : { xxl: 4, xl: 6, lg: 8, md: 12, sm: 24 };

    return data && (
        <Col key={data.id} style={{width: '24em'}}> {/* TODO {...sizes} */}
            <div onClick={onClick}
                className={'mig-card mig-card-content pointer'} 
                style={{ borderColor: data.enabled ? '#757575' : '#D9D9D9' }} 
            >
                <div style={{ width: '100%' }}>
                    <Flex vertical gap={10} >
                        <Flex justify='space-between' align='center' style={{position:'relative'}}> 
                            <span className='mig-title-3 mig-in-one-line'>{data.taskDef?.name}</span>
      
                        </Flex>
                        <Flex justify='space-between'>
                            <i className='mig-title-3 mig-in-one-line'>{data.cronExpression}</i>    
                            <small className='mig-in-one-line'>{data.title}</small>
                        </Flex>
                    </Flex>
                </div>
            </div>
        </Col>
    ) || null;
}
